/*       */

import { gql } from '@apollo/client';

export default extraFields => gql`
    query relationDefinitionsListQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "relationDefinition", filterBy: $filterBy, excludeBy: $excludeBy)
        records: relationDefinitions(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            type
            relatedType
            description
            relatedDescription
            ${extraFields || ''}
        }
    }
`;
